// ---------------------------------------------------------------------------
// Per-node-type visual style. Centralised so Stats / Legend / Canvas all
// pick from the same palette.
// ---------------------------------------------------------------------------

import type { AppGraphNodeType } from './types'

// The node-type NAMES live in the locale dictionary (`appMap.nodeTypes`),
// keyed by this same union, and the three panels read them from there. They
// were a `NODE_TYPE_LABEL` record here — one English table three components
// rendered verbatim, in every language. Deleted rather than left unused: a
// second source of names is how the copy drifts back.

export const NODE_TYPE_COLOR: Record<AppGraphNodeType, string> = {
  // Brighter tailwind 400-level values tuned for the dark zinc-950 canvas
  // background — they keep legibility and support the subtle glow
  // treatment the OpenTology-style dot nodes use (box-shadow + outline).
  app: '#818cf8', // indigo-400
  page: '#38bdf8', // sky-400
  block: '#60a5fa', // blue-400
  atom: '#fbbf24', // amber-400
  flow: '#fb7185', // rose-400
  stateVar: '#a78bfa', // violet-400
  datasource: '#0ea5e9', // sky-500
}
